import {getPublishedLearnMoreUrl} from '../../feature-promo/product-update-learn-more-url';

export type PublicProductUpdate = {
    id: string;
    slug: string;
    publishedAt: string;
    title: string;
    learnMoreUrl?: string | null;
    primaryCta?: {
        text: string;
        href: string;
        isExternal?: boolean;
    } | null;
};

type PublicProductUpdateFeedResponse = {
    updates: PublicProductUpdate[];
};

export type WhatsNewFeature = {
    text: string;
    url: string;
};

const MAX_WHATS_NEW_FEATURES = 4;

export async function fetchPublicProductUpdates(): Promise<PublicProductUpdate[]> {
    const response = await fetch('/product-updates/feed');
    if (!response.ok) {
        throw new Error('Failed to load product updates');
    }

    const data: PublicProductUpdateFeedResponse = await response.json();
    if (!data || !Array.isArray(data.updates)) {
        return [];
    }

    return data.updates;
}

function getWhatsNewFeatureUrl(update: PublicProductUpdate): string | undefined {
    const learnMoreUrl = getPublishedLearnMoreUrl(update.learnMoreUrl);
    if (learnMoreUrl) {
        return learnMoreUrl;
    }

    if (update.primaryCta && update.primaryCta.isExternal) {
        return update.primaryCta.href;
    }

    return undefined;
}

export function mapProductUpdatesForWhatsNew(
    updates: ReadonlyArray<PublicProductUpdate>
): WhatsNewFeature[] {
    const features: WhatsNewFeature[] = [];

    for (const update of updates) {
        const url = getWhatsNewFeatureUrl(update);
        if (!url) {
            continue;
        }

        features.push({
            text: update.title,
            url,
        });

        if (features.length >= MAX_WHATS_NEW_FEATURES) {
            break;
        }
    }

    return features;
}
